import { useEffect, useState } from 'react';
import { Routes, Route} from "react-router-dom";
import { Alert } from "react-bootstrap";
import { Form } from '../../types'

import InstructorMain from "../instructor/instructorMain";
import StudentMain from "../student/studentMain";
import FormCreation from "../instructor/form-creation"
import FormSubmissionsPage from './form-submissions';
import { fetchForms, createForm, updateForm } from '../../helpers';
const API_URL = process.env.REACT_APP_API_URL;


type SharedViewProps = {
  forms: Form[];
  setForms: React.Dispatch<React.SetStateAction<Form[]>>;
  refreshForms: () => Promise<void>;
};

const SharedView: React.FC<SharedViewProps> = ({ forms, setForms, refreshForms }) => {
  const [isReady, setIsReady] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const userRole = sessionStorage.getItem('role');
    useEffect(() => {
      const checkValidation = async () => {
        const response = await fetch(`${API_URL}/validate-user`, {
          credentials: 'include',
        });
        const data = await response.json();
        //console.log("Validate user response:", data);
      };
      checkValidation();
    }, []);

    useEffect(() => {
      setIsReady(true);
      const loadForms = async () => {
        const courseGuid = sessionStorage.getItem('courseGuid');
        if (!courseGuid) {
          setError("No course ID found. Please log in again.");
          return;
        }
        try {
          const fetchedForms = await fetchForms(courseGuid);
          setForms(fetchedForms);
          console.log("Form data on load:", fetchedForms);
        } catch (err) {
          console.error('Error fetching forms:', err);
          setError('Failed to load forms.');
        }
      };
      loadForms();
    }, [setForms]);

   if (!isReady) {
    return null; 
  }

  return (
<div className="container">
      {error && <Alert variant="danger">{error}</Alert>}
      <Routes>
        {userRole === "instructor" && (
          <>
            <Route 
              path="/" 
              element={<InstructorMain forms={forms} setForms={setForms} refreshForms={refreshForms} />} 
            />
            <Route 
              path="/form/new" 
              element={
                <FormCreation 
                  form={null} 
                  saveForm={createForm} 
                />
              } 
            />
            <Route 
              path="/form/:formId/edit" 
              element={
                <FormCreation 
                  updateForm={updateForm} 
                />
              } 
            />
          </>
        )}

        {userRole === "student" && (
          <Route 
            path="/" 
            element={<StudentMain forms={forms} setForms={setForms} refreshForms={refreshForms} />} 
          />
        )}

        <Route path="/form/:formId/submissions" element={<FormSubmissionsPage refreshForms={refreshForms} />} />
      </Routes>
    </div>
  );
}

export default SharedView;